angular.module('mtic').constant('IAM_CONFIGURATION', {
    "microsoft": {
        "clientId": "ca56dac5-0fcb-4745-8cfd-2bef47397dc3",
        "instance": "https://login.microsoftonline.com/",
        "cacheLocation": "localStorage",
        "redirectUri": window.location.href,
        "postLogoutRedirectUri": window.location.href,
        "navigateToLoginRequestUrl": false
    }
})
